import React from 'react';
import { connect } from 'react-redux';
import { bool, func, object, string } from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';

import LogoNav from 'dibs-logo/exports/LogoNav';
import Notifications from '../Notifications/Notifications';
import { SearchBar } from '../SearchBar/SearchBar';
import AccountNav from '../AccountNav/AccountNav';
import Likes from '../Likes/Likes';
import CartNav from '../CartNav/CartNav';

import styles from './TopBar-style.scss';

const TopBarComponent = props => {
    const {
        disableStickyNav,
        hasRootPendingRefetch,
        hasUserId,
        hasUser,
        isClient,
        user,
        userId,
        viewer,
        onMouseOver,
        onMouseOut,
        hasError,
        isEmailOnly,
    } = props;
    const { isNotificationsEnabled, isFavoritesEnabled, isCartEnabled } = viewer;

    const barClasses = classnames({
        [styles.bar]: true,
        [styles.disableSticky]: disableStickyNav,
    });

    if (hasError) {
        return (
            <div className={barClasses}>
                <div className={`${styles.barContent} js-nav-utils-wrap`}>
                    <div className={styles.leftContainer}>
                        <LogoNav />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={barClasses} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            <div className={`${styles.barContent} js-nav-utils-wrap`}>
                <div className={styles.leftContainer}>
                    <LogoNav />
                    <SearchBar
                        hasClickableSearchButton
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        isClient={isClient}
                        viewer={viewer}
                    />
                </div>
                <div className={styles.rightContainer}>
                    <AccountNav
                        isClient={isClient}
                        hasUser={hasUser}
                        hasUserId={hasUserId}
                        viewer={viewer}
                        user={user}
                    />

                    {isNotificationsEnabled && !isEmailOnly && (
                        <Notifications
                            hasRootPendingRefetch={hasRootPendingRefetch}
                            hasUserId={hasUserId}
                            isClient={isClient}
                            userId={userId}
                            viewer={viewer}
                            initialViewer={viewer}
                            user={user}
                        />
                    )}

                    {isFavoritesEnabled && (
                        <Likes
                            hasRootPendingRefetch={hasRootPendingRefetch}
                            hasUserId={hasUserId}
                            fetchNewEvents={hasUserId && isClient && !hasRootPendingRefetch}
                            isClient={isClient}
                            userId={userId}
                            viewer={viewer}
                        />
                    )}

                    {isCartEnabled && (
                        <CartNav
                            hasRootPendingRefetch={hasRootPendingRefetch}
                            hasUserId={hasUserId}
                            isClient={isClient}
                            user={user}
                            userId={userId}
                            viewer={viewer}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

TopBarComponent.propTypes = {
    hasError: bool,
    disableStickyNav: bool,
    hasRootPendingRefetch: bool,
    hasUser: bool,
    hasUserId: bool,
    isClient: bool,
    openDrawer: func,
    user: object,
    userId: string,
    viewer: object,
    onMouseOver: func,
    onMouseOut: func,
    isEmailOnly: bool,
};

const mapStateToProps = ({ header }) => ({
    isEmailOnly: header.isEmailOnly,
});

export const TopBar = createFragmentContainer(connect(mapStateToProps)(TopBarComponent), {
    viewer: graphql`
        fragment TopBar_viewer on Viewer
        @argumentDefinitions(hasSessionCountryCode: { type: "Boolean!", defaultValue: false }) {
            isNotificationsEnabled: isEnabledByLocale(featureName: "NOTIFICATIONS")
            isFavoritesEnabled: isEnabledByLocale(featureName: "FAVORITES")
            isCartEnabled: isEnabledByLocale(featureName: "CART")
            ...AccountNav_viewer
            ...CartNav_viewer
            ...Likes_viewer
            ...Notifications_viewer @arguments(hasSessionCountryCode: $hasSessionCountryCode)
            ...Notifications_initialViewer
            ...SearchBar_viewer
        }
    `,
    user: graphql`
        fragment TopBar_user on User {
            ... @include(if: $isClient) {
                ...AccountNav_user
                ...CartNav_user
                ...Notifications_user
            }
        }
    `,
});
